module.exports = __webpack_public_path__ + "img/ic-pt-bracelet.128e838c.svg";